// React
import React from 'react';

// Vendors
import { Icon } from '@equisoft/design-elements-react';

// Styles
import classes from './NotFound.module.scss';

const NotFoundPage = () => (
    <div className={classes.Root}>
        <Icon
            name="info"
            className={classes.Icon}
        />
        <div className={classes.Title}>Not found Page</div>
        <div className={classes.Description}>...</div>
    </div>
);

export default NotFoundPage;
